import { groupBy } from 'es-toolkit'
import { useEffect, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { Header } from '@/components/shared/header'
import { AuthImage } from '@/components/ui/auth-image'
import { useGoBack } from '@/hooks/useGoBack'
import { useAppStore } from '@/store/useAppStore'
import { useMediaStore } from '@/store/useMediaStore'

export const ContentsCheck = () => {
  const { getProducts, products, domain } = useMediaStore(useShallow((state) => state))
  const { startLoading, stopLoading } = useAppStore(useShallow((state) => state))

  const goBack = useGoBack()

  useEffect(() => {
    if (domain !== 'line') {
      startLoading()
      getProducts({ domain: 'line', missing: true }, () => stopLoading(), false)
    }
  }, [domain, getProducts, startLoading, stopLoading])

  const customProducts = useMemo(() => {
    if (!products || domain !== 'line') return []
    // エピソードのインデックスが連続していないプロダクトをフィルタリング
    const g = groupBy(products.products, (product) => product.domain_product_id)

    const nonConsecutiveProducts = Object.keys(g)
      .map((key) => g[key][0])

      .map((product) => {
        const maxIndex = Math.max(...product.episodes.map((episode) => episode.index))
        const indexArr = Array.from({ length: maxIndex }, (_, i) => i + 1)
        const missingIndexes = indexArr.filter((index) => !product.episodes.some((episode) => episode.index === index))
        return { ...product, missingIndexes, maxIndex }
      })
      .filter((product) => product.missingIndexes.length > 0)

    return nonConsecutiveProducts
  }, [domain, products])

  return (
    <div>
      <Header title="Contents Check" onClose={goBack} />
      <div className="divide-y divide-border">
        {customProducts.map((p) => (
          <div key={p.product_id} className="p-4 flex gap-4">
            {/* サムネイル */}
            <div className="shrink-0 w-20 h-28 rounded overflow-hidden bg-muted">
              <AuthImage
                src={`/api/p/${p.product_id}/thumbnail`}
                alt={p.title}
                className="w-full h-full object-cover"
              />
            </div>
            {/* コンテンツ */}
            <div className="flex-1 space-y-2 min-w-0">
              <div className="font-medium">{p.title}</div>
              <div className="text-sm text-muted-foreground wrap-break-word whitespace-normal">
                欠番: {p.missingIndexes.join(', ')}
              </div>
              <div className="text-sm text-muted-foreground">{p.maxIndex}ページ中</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
